<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import { useAppConfiguration } from "@domain/AppConfiguration";

import ColorPalette from "./Components/ColorPalette.vue";

useBackButton( true, true );

</script>

<template>

    <div class="bg-gradient-to-b dark:from-gray-900 via-60% dark:via-gray-850 dark:to-gray-850/60
                text-base lg:text-lg
                w-full h-full overflow-y-auto overflow-x-hidden flex flex-col pb-12">
                    
        <div class="p-6 text-center text-purple-500 uppercase font-bold">
            <h2 class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                <Icon name="debug" 
                      class="text-3xl 3xl:text-4xl opacity-70" />
                  Debug
            </h2>
        </div>   
                
        <ColorPalette />

    </div>
    
</template>